import { Outlet } from 'react-router-dom'
import { PWADebug } from '@/components/ui/PWADebug'
import { InstallPrompt } from '@/components/ui/InstallPrompt'

const Layout = () => {

    return (
        <div className="min-h-screen bg-background">
            {/* You can add a header, sidebar, or other layout elements here */}
            <main>
                <Outlet />
            </main>

            {/* Install prompt fixed at bottom, overlaying content */}
            <div className="fixed bottom-0 left-0 right-0 z-40">
                <InstallPrompt />
            </div>

            {/* Temporary debug component - remove when issue is resolved */}
            {/*<PWADebug />*/}
        </div>
    )
}

export default Layout 